module.exports = __webpack_public_path__ + "assets/media/sampleAudio.2b749ebf.aac";